import { Component, Input, Output, ViewChild, EventEmitter, OnInit, ElementRef } from '@angular/core'

import { Address, blankAddress } from '../../common/models/address'
import { AddressDB } from '../models/address'

import { State } from '../../common/models/state'
import { User } from '../models/user'
import { WebUserComment } from '../models/web-user-comments'
import { UserGateway } from '../gateways/user-gateway'
import { UserCommentsGateway } from '../gateways/user-comments-gateway'
import { UserProfileGateway } from '../gateways/user-profile-gateway'
import { CommissionLevelGateway } from '../gateways/commission-level-gateway'
import { CurrentUserGateway } from '../../common/gateways/current-user-gateway'

import { UserProfile } from '../models/user-profile'
import { UserPersonalDetails } from '../models/user-personal-details'

import { UserPhone } from '../../common/models/user-phone'
import { UserPhoneDB } from '../models/user-phone'
import { BackGroundCheck } from '../models/background-check'
import { CurrentUser } from '../../common/models/current-user'

import { Router, ActivatedRoute, Params } from '@angular/router'
import { FormValidationService } from '../../validations/form-validation-service'
import { UserProfileComponent } from '../components/profile-details/user-profile-component'
import { BusinessAndResidentialAddressComponent } from '../../common/components/address-group/business-and-residential-address.component'
import { UserPersonalDetailsComponent } from '../components/personal-details/user-personal-details-component'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { ValidatedCheckboxComponent } from '../../validations/validated-checkbox.component'
import { NumericTextFieldValidator } from '../../validations/numeric-text-field-validator'
import { License } from '../models/license-details'
import { LicenseApptGateway } from '../gateways/license-appt-gateway'
import { UserTypeGateway } from '../gateways/user-type-gateway'
import { UserDataService } from '../gateways/common-data-service'
import { UserProfileRoleOrganization } from '../models/user-profile-role-org'
import { PasswordTextFieldValidator } from '../../validations/password-text-field-validator'
import { PortalGlobals } from '../../portalglobals'
import * as moment from 'moment'

@Component({
    selector: 'userComponent',
    templateUrl: 'user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
    user: any = {} as any
    addresses: any[] = [] as any[]
    userPhones: UserPhoneDB[] = [] as UserPhoneDB[]
    comments: WebUserComment[] = [] as WebUserComment[]
    licenseViewModel: License[] = [] as License[]
    errorMessage = ''
    states: State[] = [] as State[]
    commentsViewModel: WebUserComment[] = [] as WebUserComment[]
    CommentinsertModel: WebUserComment = {} as WebUserComment

    viewUserProfile: UserProfile = {} as UserProfile
    personalDetails: UserPersonalDetails = {} as UserPersonalDetails
    bgCheck: BackGroundCheck = {} as BackGroundCheck
    currentUser: CurrentUser = {} as CurrentUser
    userProfileRoleOrganization = {} as UserProfileRoleOrganization
    @ViewChild(UserProfileComponent, { static: true }) userProfileComponent: UserProfileComponent
    @ViewChild(UserPersonalDetailsComponent, { static: true }) personalDetailsComponent: UserPersonalDetailsComponent
    @ViewChild(BusinessAndResidentialAddressComponent, { static: true })
    businessAndResidentialAddressComponent: BusinessAndResidentialAddressComponent

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    @Output() onValueChange: EventEmitter<Address> = new EventEmitter<Address>()
    passwordValidator: PasswordTextFieldValidator = new PasswordTextFieldValidator()
    // @Input() disabled = false
    @Input() allowPOBoxes = true

    chkbox: ValidatedCheckboxComponent

    mode = 'add'
    display = ''
    userProfileID = 0
    isReadOnly = false
    isAdminUpdate = false
    isFormValid: boolean
    isFormServiceValidationValid: boolean
    successOrErrorMessage: string
    ErrorMessages: any[]
    pageTitle = ''
    userStatusReason: ValidatedSelectOptionModel[]
    AttestedDetails = ''
    numericValidator = new NumericTextFieldValidator()
    bgChkResultDate: any
    commentsScreenShow = false
    licenseScreenShow = false
    trainingScreenShow = false
    showCommentsTab = false
    showLicenseTab = false
    showTrainingTab = false
    validateeContract = false
    zip4text: string
    errorlist: any[]
    errorlists: any[]
    residentialAddrID = 0
    isRequired = false
    selectedRoleID: number
    userType: ValidatedSelectOptionModel[]
    userTypeDescription: string
    isLogInDisabled = false
    validateEmpID = false
    displayEmpID = false
    isAddMode = false
    ifWarnings = false
    Warnings: any[]
    isBackGroundDisabled: boolean = true
    isStatusDisabled: boolean = true
    noMiddleName = false
    eContractValue: string
    econtractChange: boolean
    showEContract: boolean = false
    showEContractOrg: boolean = false
    showEContractUserType: boolean = false
    econtractDisable: boolean = false
    bgChkStatus: number = 0
    isAuditor: boolean = false
    iscontract: string
    isfromUserSearch: string
    userProfileStatusReason: string

    @Input()
    set residentialAddress(value: Address) {
        if (value) {
            this._residentialAddress = value
        } else {
            this._residentialAddress = blankAddress()
        }
    }
    get residentialAddress(): Address {
        return this._residentialAddress
    }

    @Input()
    set businessAddress(value: Address) {
        if (value) {
            this._businessAddress = value
        } else {
            this._businessAddress = blankAddress()
        }
    }
    get businessAddress(): Address {
        return this._businessAddress
    }

    _businessAddress: Address = blankAddress()
    _residentialAddress: Address = blankAddress()

    @Input()
    set businessPhone(value: UserPhone) {
        this._businessPhone = value
    }
    get businessPhone(): UserPhone {
        return this._businessPhone
    }

    @Input()
    set cellPhone(value: UserPhone) {
        this._cellPhone = value
    }
    get cellPhone(): UserPhone {
        return this._cellPhone
    }

    @Input()
    set silverMailOptIn(value: boolean) {
        this._silverMailOptIn = value
    }
    get silverMailOptIn(): boolean {
        return this._silverMailOptIn
    }

    _silverMailOptIn: boolean
    _businessPhone: UserPhone = {} as UserPhone
    _cellPhone: UserPhone = {} as UserPhone

    showBusinessAndResidentialAddressComponent = true

    insCo: string

    constructor(
        private _userGateway: UserGateway,
        private userCommentsGateway: UserCommentsGateway,
        private userProfileGateway: UserProfileGateway,
        protected formValidationService: FormValidationService,
        public element: ElementRef,
        private route: ActivatedRoute,
        private comLevelGateway: CommissionLevelGateway,
        private licenseApptGateway: LicenseApptGateway,
        private routers: Router,
        private curUserGateway: CurrentUserGateway,
        private userTypeGateway: UserTypeGateway,
        private userDataService: UserDataService,
        public _global: PortalGlobals
    ) {
        this.route.params.forEach((params: Params) => {
            if (params['mode']) {
                this.mode = params['mode']
            }
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
            }
            if (params['isfromUserSearch']) {
                this.isfromUserSearch = params['isfromUserSearch']
            }
        })
        if (this.mode === 'edit' && this.userProfileID === 0) {
            this.isAdminUpdate = true
            this.isAddMode = false
        }

        /**
         * comments: NA - 05-21-2019
         * This conidition is used for Aetna organizations.
         * We are not allowing the users to update their profile if user is belongs to Aetna orgs on the basis of the LockEditUsers Flag
         */
        if (this.isAdminUpdate) {
            if (this._global.currentUser.LockEditUsers === true) {
                const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                const userprofileid = this._global.currentUser.userProfileId
                this.routers.navigate(['/' + insCo + '/user-management/my-profile/' + userprofileid + '/1'])
            }
        }

        curUserGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
            this.currentUser = currentUserModel
            this._global.currentUser = currentUserModel
            this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.isAuditor = this.currentUser.isAuditor
            if (this.mode === 'edit' && !this.isAdminUpdate) {
                this.isLogInDisabled = true

                if (this.currentUser !== undefined && this.currentUser !== null) {
                    if (this.currentUser.IsGuruAdmin || this.currentUser.IsSuperAdminAdmin) {
                        this.isLogInDisabled = false
                    }
                }
            }
        })
        this.isFormValid = true
        this.isFormServiceValidationValid = true
        this.ErrorMessages = []
        this.successOrErrorMessage = ''
        this.Warnings = []
        this.ifWarnings = false
    }

    ngOnInit() {
        if (this._global.currentUser !== null && this._global.currentUser !== undefined) {
            this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.getDataInPageload()
        } else {
            this.curUserGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
                this.currentUser = currentUserModel
                this._global.currentUser = currentUserModel
                this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                this.getDataInPageload()
            })
        }
    }

    getDataInPageload() {
        //if (this._global.currentUser.IsGuruAdmin || this._global.currentUser.IsSuperAdminAdmin || this._global.currentUser.IsImAdminOrAbove || this._global.currentUser.isOrganizationalManager || this._global.currentUser.isOrganizationalAdmin || this._global.currentUser.IsAdminOrAgent || this._global.currentUser.IsSuperAdminSMA || this._global.currentUser.IsSuperAdminSMM) {
        //    this.isBackGroundDisabled = false
        //}

        if (
            this._global.currentUser.IsGuruAdmin ||
            this._global.currentUser.IsSuperAdminAdmin ||
            this._global.currentUser.IsSuperAdminSMA ||
            this._global.currentUser.IsSuperAdminSMM
        ) {
            this.isBackGroundDisabled = false
        }

        //if (this._global.currentUser.IsAdmin && !this._global.currentUser.isOrganizationalAdmin) {
        //    this.isStatusDisabled = false
        //}

        if (this._global.currentUser.IsAdmin || this._global.currentUser.isOrganizationalManager) {
            // && !this._global.currentUser.IsAdminOrAgent)
            this.isStatusDisabled = false
        }

        this.isAuditor = this._global.currentUser.isAuditor
        this.isFormValid = true

        if (this.mode === 'edit') {
            this.isAddMode = false
            if (this.isAdminUpdate) {
                this.pageTitle = 'Update Profile'
                this.UpdateSettingsForAdmin()
                this.isReadOnly = true
                this._userGateway.retrieveAdminPersonalDetails().subscribe((model) => {
                    this.user = model
                    this.addresses = this.user.Address
                    this.userPhones = this.user.UserPhones
                    this.userProfileRoleOrganization = this.user.UserProfileRoleOrganization
                    this.personalDetails = {} as UserPersonalDetails
                    if (model.Warnings !== null && model.Warnings !== undefined) {
                        if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                            this.ifWarnings = true
                            this.Warnings = this.user.Warnings
                        }
                    }
                    this.setPersonalDetails()
                    this.setResidentialAndBussinessAddresses()
                })
            } else {
                this.pageTitle = 'Edit User Profile'
                this.UpdateSettingsForEdit()

                // if (this._global.currentUser.roleCode.indexOf('Admin') < 0)
                //     this.routers.navigateByUrl('/home')
                this._userGateway.retrieveUser(this.userProfileID).subscribe(
                    (model) => {
                        this.user = model
                        this.addresses = this.user.Address
                        this.userPhones = this.user.UserPhones

                        this.viewUserProfile = this.user.UserProfile

                        this.getUserTypesForEcontract()
                        this.eContractValue = this.viewUserProfile.AttestationAccepted

                        this.userProfileRoleOrganization = this.user.UserProfileRoleOrganization
                        console.log('roleorgis' + this.userProfileRoleOrganization)
                        sessionStorage.setItem('editUserOrg', this.userProfileRoleOrganization.OrgID.toString())
                        this.personalDetails = {} as UserPersonalDetails
                        if (model.UserProfile.UserLoginType !== null && model.UserProfile.UserLoginType.toLowerCase() === 'internal') {
                            if (model.Warnings !== null && model.Warnings !== undefined) {
                                if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                                    this.ifWarnings = true
                                    this.Warnings = this.user.Warnings
                                }
                            }
                        }
                        this.setPersonalDetails()
                        this.setResidentialAndBussinessAddresses()
                        this.getStatusReason()
                        // this.getUserTypes()
                        if (this.viewUserProfile.RecCreateTS !== null)
                            this.viewUserProfile.RecCreateTSString = moment(this.viewUserProfile.RecCreateTS)
                                .subtract(7, 'h')
                                .format('MM/DD/YYYY hh:mm:ss A')
                                .toString()
                    },
                    (error) => (this.errorMessage = <any>error)
                )
                // this.getUserComments()
                //  this.getUserLicense()
                document.getElementById('divProfileHistory')!.style.display = 'block'
            }
            // this.getUserLicense()
        } else {
            this.isAddMode = true
            this.UpdateSettingsForAdd()
            this.getUserTypes()
            this.residentialAddress.state.code = '0'
            this.businessAddress.state.code = '0'
        }
    }

    getUserComments() {
        this.userCommentsGateway.getUserCommentsData(this.userProfileID).subscribe((model: WebUserComment[]) => {
            this.commentsViewModel = model
            //for (let i = 0; i < this.commentsViewModel.length; i++) {
            //    if (this.commentsViewModel[i].Comment === undefined || this.commentsViewModel[i].Comment === '') {
            //        this.commentsViewModel[i].Comment = 'No comment entered. Comment not save.'
            //    }
            //}
        })
    }

    setResidentialAndBussinessAddresses() {
        this.silverMailOptIn = this.user.UserProfile.SilverMailOptIn

        if (this.addresses.length > 0) {
            let currentResidentialAddress = this.addresses.filter((x) => x.AddressType === 'Home')[0]
            let currentBusinessAddress = this.addresses.filter((x) => x.AddressType === 'Business')[0]
            if (currentResidentialAddress !== null && currentResidentialAddress !== undefined) {
                this.residentialAddrID = this.residentialAddress.id = currentResidentialAddress.AddressID
                this.residentialAddress.line2 = currentResidentialAddress.AddressLine2
                this.residentialAddress.line1 = currentResidentialAddress.AddressLine1
                this.residentialAddress.city = currentResidentialAddress.City
                this.residentialAddress.state.code = currentResidentialAddress.State
                this.residentialAddress.zip = currentResidentialAddress.Zip
                this.residentialAddress.zip4 = currentResidentialAddress.Zip4
            }
            if (currentBusinessAddress !== null && currentBusinessAddress !== undefined) {
                this.businessAddress.id = currentBusinessAddress.AddressID
                this.businessAddress.line2 = currentBusinessAddress.AddressLine2
                this.businessAddress.line1 = currentBusinessAddress.AddressLine1
                this.businessAddress.city = currentBusinessAddress.City
                this.businessAddress.state.code = currentBusinessAddress.State
                this.businessAddress.zip = currentBusinessAddress.Zip
                this.businessAddress.zip4 = currentBusinessAddress.Zip4
            }

            if (this.userPhones.length > 0) {
                let businessPhone = this.userPhones.filter((phone) => phone.PhoneType === 'Business')[0]
                let cellPhone = this.userPhones.filter((phone) => phone.PhoneType === 'Cell')[0]
                if (businessPhone) {
                    this.businessPhone.Phone = businessPhone.Phone
                    this.businessPhone.PhoneType = businessPhone.PhoneType
                    this.businessPhone.PhoneTypeID = businessPhone.PhoneTypeID
                    this.businessPhone.UserPhoneID = businessPhone.UserPhoneID
                } else {
                    this.addDefaultBusinessPhone()
                }
                if (cellPhone) {
                    this.cellPhone.Phone = cellPhone.Phone
                    this.cellPhone.PhoneType = cellPhone.PhoneType
                    this.cellPhone.PhoneTypeID = cellPhone.PhoneTypeID
                    this.cellPhone.UserPhoneID = cellPhone.UserPhoneID
                } else {
                    // if(this.mode !== 'edit')
                    this.addDefaultCellPhone()
                }
            } else {
                this.addDefaultBusinessPhone()
                this.addDefaultCellPhone()
            }
        }
    }

    addDefaultBusinessPhone() {
        this.businessPhone.PhoneType = 'Business'
        this.businessPhone.UserPhoneID = 0
        this.businessPhone.PhoneTypeID = 3
        this.businessPhone.Phone = ''
        let bPhone = {} as UserPhoneDB
        bPhone.PhoneType = 'Business'
        bPhone.PhoneTypeID = 3
        bPhone.UserPhoneID = 0
        bPhone.Phone = ''
        this.userPhones.push(bPhone)
    }

    addDefaultCellPhone() {
        this.cellPhone.PhoneType = 'Cell'
        this.cellPhone.UserPhoneID = 0
        this.cellPhone.PhoneTypeID = 2
        this.cellPhone.Phone = ''
        let cPhone = {} as UserPhoneDB
        cPhone.PhoneType = 'Cell'
        cPhone.PhoneTypeID = 2
        cPhone.UserPhoneID = 0
        cPhone.Phone = ''
        this.userPhones.push(cPhone)
    }

    businessAddressChanged(address: any) {
        this.residentialAddress = address
    }

    residentialAddressChanged(address: any) {
        this.residentialAddress = address
    }
    silverMailOptInChanged(checked: any) {
        this.silverMailOptIn = checked
    }

    onCommentAdded(webUserComment: WebUserComment) {
        this.userCommentsGateway.addUsercomments(webUserComment, this.userProfileID).subscribe(
            (model: WebUserComment) => {
                this.CommentinsertModel = model
                this.getUserComments()
            },
            (error) => {
                this.successOrErrorMessage = 'An error occured while saving comments'
                this.getUserComments()
            }
        )
        // this.getUserComments()
    }

    getUserLicense() {
        this.licenseApptGateway.getUserLicenseDetails(this.userProfileID).subscribe((model: License[]) => {
            this.licenseViewModel = model
            this.licenseViewModel.forEach((licenses) => {
                if (licenses.LicenseExpirationDate !== null) {
                    licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentTerminationDate !== null) {
                    licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentEffectiveDate !== null) {
                    licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                }

                licenses.EditRow = false
            })
        })
    }

    submitForm() {
        let residentialAddress = {} as AddressDB
        let businessAddress = {} as AddressDB

        residentialAddress.addressID = this.mode === 'edit' ? this.residentialAddrID : this.residentialAddress.id
        residentialAddress.addressLine1 = this.residentialAddress.line1
        residentialAddress.addressLine2 = this.residentialAddress.line2 || ''
        residentialAddress.city = this.residentialAddress.city
        residentialAddress.state = this.residentialAddress.state.code
        residentialAddress.zip = this.residentialAddress.zip
        residentialAddress.zip4 = this.residentialAddress.zip4
        residentialAddress.addressType = 'Home'

        businessAddress.addressID = this.businessAddress.id
        businessAddress.addressLine1 = this.businessAddress.line1
        businessAddress.addressLine2 = this.businessAddress.line2 || ''
        businessAddress.city = this.businessAddress.city
        businessAddress.state = this.businessAddress.state.code
        businessAddress.zip = this.businessAddress.zip
        businessAddress.zip4 = this.businessAddress.zip4
        businessAddress.addressType = 'Business'

        let businessPhone = {} as UserPhoneDB
        let cellPhone = {} as UserPhoneDB

        businessPhone.Phone = this.businessPhone.Phone
        businessPhone.PhoneType = 'Business'
        // this.businessPhone.PhoneType
        businessPhone.PhoneTypeID = this.businessPhone.PhoneTypeID
        businessPhone.UserPhoneID = this.businessPhone.UserPhoneID

        if (this.cellPhone.Phone !== undefined && this.cellPhone.Phone !== null) {
            cellPhone.Phone = this.cellPhone.Phone.trim() == '' ? '' : this.cellPhone.Phone
            cellPhone.PhoneType = 'Cell'
            cellPhone.PhoneTypeID = this.cellPhone.PhoneTypeID
            cellPhone.UserPhoneID = this.cellPhone.UserPhoneID
        }

        if (this.mode === 'add') {
            this.addresses = []
            this.userPhones = []

            this.addresses.push(residentialAddress)

            this.addresses.push(businessAddress)
            if (this.businessPhone.Phone !== undefined && this.businessPhone.Phone !== null && this.businessPhone.Phone !== '')
                this.userPhones.push(businessPhone)

            if (this.cellPhone.Phone !== undefined && this.cellPhone.Phone !== null && this.cellPhone.Phone !== '') {
                if (this.cellPhone.Phone.trim() !== '') this.userPhones.push(cellPhone)
            }
        } else {
            this.addresses[0] = residentialAddress
            this.addresses[1] = businessAddress

            this.userPhones = []

            if (this.businessPhone.Phone !== undefined && this.businessPhone.Phone !== null && this.businessPhone.Phone !== '')
                this.userPhones.push(businessPhone)

            if (cellPhone.UserPhoneID !== null && cellPhone.UserPhoneID !== undefined && cellPhone.UserPhoneID !== 0) {
                this.userPhones.push(cellPhone)
            } else {
                if (this.cellPhone.Phone !== undefined && this.cellPhone.Phone !== null && this.cellPhone.Phone !== '') {
                    if (this.cellPhone.Phone.trim() !== '') {
                        this.userPhones.push(cellPhone)
                    } else {
                    }
                }
            }
        }

        this.user.Address = this.addresses
        this.user.UserPhones = this.userPhones
        this.user.PersonalDetails = this.personalDetailsComponent.personalDetails
        this.user.UserProfile = this.userProfileComponent.viewUserProfile

        if (this.isAdminUpdate) {
            this.user.UserProfile.SilverMailOptIn = this.silverMailOptIn
        }
        this.assignFormDatatoUserProfile()
        this.user.UserProfileRoleOrganization = this.userProfileRoleOrganization

        this.isFormValid = true
        this.isFormServiceValidationValid = true
        this.successOrErrorMessage = ''

        this.isFormValid = true
        this.Warnings = []
        this.ifWarnings = false
        this.formValidationService.validateAll(
            () => {
                this.validateForm()
                if (this.isFormValid === true) {
                    this.onAddProfile(this.user)
                } else {
                    this.focusableEleTop.nativeElement.focus()
                }
            },
            () => {
                this.onErrors()
                this.validateForm()
                if (this.ErrorMessages.length == 0) {
                    this.isFormValid = true
                } else {
                    this.focusableEleTop.nativeElement.focus()
                }
            }
        )
    }

    onErrors() {
        this.isFormValid = false

        this.focusableEleTop.nativeElement.focus()
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    onAddProfile(user: User) {
        this.focusableEleTop.nativeElement.focus()

        if (this.mode === 'add') {
            this.userProfileGateway.createUserProfile(user).subscribe(
                (model: User) => {
                    this.user = {} as User
                    this.user = model
                    // this.personalDetails = {} as UserPersonalDetails
                    // this.viewUserProfile = {} as UserProfile
                    this.isFormValid = true
                    this.successOrErrorMessage = 'User Profile Created Successfully'
                    if (this.user !== null && this.user !== undefined) {
                        if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                            this.ifWarnings = true
                            this.Warnings = this.user.Warnings
                        }
                    }
                    const insuranceCompany = this.insCo.toLowerCase()
                    setTimeout(() => {
                        this.routers.navigateByUrl('/' + insuranceCompany + '/user-management/edit-user/edit/' + model.UserProfile.UserProfileID)
                    }, 5000)
                },
                (error) => {
                    this.successOrErrorMessage = ''
                    this.ErrorMessages = this.extractErrorMessages(error)
                    this.isFormValid = false
                    this.focusableEleTop.nativeElement.focus()
                }
            )
        } else {
            if (this.isAdminUpdate) {
                this.userProfileGateway.updateAdminPersonalDetails(user).subscribe(
                    (model: User) => {
                        this.user = {} as User
                        this.isFormValid = true
                        this.successOrErrorMessage = 'User Profile Updated Successfully'
                    },
                    (error) => {
                        this.successOrErrorMessage = 'An error occured while updating user profile'
                    }
                )
            } else {
                if (user.UserProfile.AttestationAccepted !== undefined && user.UserProfile.AttestationAccepted !== null) {
                    console.log(this.eContractValue)
                    if (this.eContractValue == null || user.UserProfile.AttestationAccepted.toString() !== this.eContractValue.toString()) {
                        user.UserProfile.ContractUserName = this._global.currentUser.userProfileName
                        user.UserProfile.eContractChange = true
                    }
                }

                this.userProfileGateway.updateUserProfile(user).subscribe(
                    (model: User) => {
                        this.user = {} as User
                        this.user = model
                        if (model.UserProfile.AttestationAccepted !== undefined && model.UserProfile.AttestationAccepted !== null) {
                            if (model.UserProfile.AttestationAccepted.toString() === '0') {
                                this.AttestedDetails =
                                    'Removed by ' +
                                    model.UserProfile.ContractUserName +
                                    ' on ' +
                                    moment(model.UserProfile.AttestationDate).utc().subtract(7, 'h').format('MM/DD/YYYY hh:mm:ss A').toString()
                            } else {
                                this.AttestedDetails =
                                    'Accepted by ' +
                                    model.UserProfile.ContractUserName +
                                    ' on ' +
                                    moment(model.UserProfile.AttestationDate).utc().subtract(7, 'h').format('MM/DD/YYYY hh:mm:ss A').toString()
                            }
                        }
                        this.isFormValid = true
                        this.successOrErrorMessage = 'User Profile Updated Successfully'
                        if (this.user !== null && this.user !== undefined) {
                            if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                                this.ifWarnings = true
                                this.Warnings = this.user.Warnings
                            }
                        }
                    },
                    (error) => {
                        this.successOrErrorMessage = ''
                        this.ErrorMessages = this.extractErrorMessages(error)
                        this.isFormValid = false
                        this.focusableEleTop.nativeElement.focus()
                    }
                )
            }
        }
    }

    private extractErrorMessages(error: any): string[] {
        const previousPasswordMessage = 'You cannot use a previous password'

        const mapToDisplayMessages = (messages: string[]): string[] => {
            const normalized = messages.map((m) => String(m || ''))
            const hasPreviousPasswordError = normalized.some(
                (m) => m.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0
            )

            if (hasPreviousPasswordError) {
                return [previousPasswordMessage]
            }

            return normalized
        }

        if (error && error.error) {
            if (Array.isArray(error.error)) {
                return mapToDisplayMessages(error.error)
            }

            if (typeof error.error === 'string') {
                try {
                    const parsed = JSON.parse(error.error)
                    if (Array.isArray(parsed)) {
                        return mapToDisplayMessages(parsed)
                    }
                } catch {
                    if (error.error.length > 0) {
                        if (error.error.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                            return [previousPasswordMessage]
                        }
                        return [error.error]
                    }
                }
            }
        }

        if (error && typeof error.statusText === 'string' && error.statusText.length > 0) {
            try {
                const parsedStatus = JSON.parse(error.statusText)
                if (Array.isArray(parsedStatus)) {
                    return mapToDisplayMessages(parsedStatus)
                }
            } catch {
                if (error.statusText.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                    return [previousPasswordMessage]
                }
                if (error.statusText !== 'Unknown Error') {
                    return [error.statusText]
                }
            }
        }

        return ['Something went wrong, please try again.']
    }

    assignFormDatatoUserProfile() {
        if (
            this.personalDetailsComponent.personalDetails.UserProfileName !== '' &&
            this.personalDetailsComponent.personalDetails.UserProfileName !== undefined
        ) {
            this.user.UserProfile.UserProfileName = this.personalDetailsComponent.personalDetails.UserProfileName.trim()
        }
        if (this.userProfileRoleOrganization === null || this.userProfileRoleOrganization === undefined)
            this.userProfileRoleOrganization = {} as UserProfileRoleOrganization

        this.userProfileRoleOrganization.OrgID = this.user.UserProfile.OrgID = this.personalDetailsComponent.personalDetails.OrgID
        this.userProfileRoleOrganization.RoleDefinitionID = this.user.UserProfile.RoleID = this.personalDetailsComponent.personalDetails.RoleID
        this.user.UserProfile.FirstName = this.personalDetailsComponent.personalDetails.FirstName
        this.user.UserProfile.LastName = this.personalDetailsComponent.personalDetails.LastName
        this.user.UserProfile.MiddleName = this.personalDetailsComponent.personalDetails.MiddleName
        this.user.UserProfile.Email = this.personalDetailsComponent.personalDetails.Email
        this.user.UserProfile.UID = this.personalDetailsComponent.personalDetails.UID
        this.user.UserProfile.LoginPassword = this.personalDetailsComponent.personalDetails.LoginPassword
        this.userProfileRoleOrganization.UserProfileID = this.user.UserProfile.UserProfileID =
            this.personalDetailsComponent.personalDetails.UserProfileID
        this.user.UserProfile.UserTypeDesc = this.personalDetailsComponent.personalDetails.UserTypeDesc

        this.user.UserProfile.UserLoginType = this.validateEmpID ? 'Internal' : 'External'
        if (!this.validateEmpID) {
            this.user.UserProfile.UID = null
            this.personalDetailsComponent.personalDetails.UID = ''
        }
        if (this.mode === 'edit') {
            this.user.UserProfile.UserProfileStatusId = this.personalDetails.UserProfileStatusId
            this.user.UserProfile.UserProfileStatusReason = this.personalDetails.UserProfileStatusReason

            if (this.user.BackGroundCheck === null || this.user.BackGroundCheck === undefined) {
                this.user.BackGroundCheck = {} as BackGroundCheck
            }

            // this.user.BackGroundCheck.BGCheck = this.personalDetails.BGCheck
            // this.user.BackGroundCheck.BackGroundCheckDate = this.personalDetails.BackGroundCheckDate
            this.user.BackGroundCheck.BgApproved = this.personalDetails.BgApproved
            if (this.bgChkStatus === 0 && this.personalDetails.BgApproved !== null && this.personalDetails.BgApproved !== undefined) {
                if (
                    this.personalDetails.BgApproved.toString() == '1' &&
                    this.personalDetails.SSN !== undefined &&
                    this.personalDetails.SSN !== null &&
                    this.personalDetails.dateofBirth !== undefined &&
                    this.personalDetails.dateofBirth !== null
                ) {
                    this.user.UserProfile.SSN = this.personalDetails.SSN
                    this.user.UserProfile.dateofBirth = this.personalDetails.dateofBirth
                }
            }
            // this.user.BackGroundCheck.BgApprovedDate = this.personalDetails.BgApprovedDate
        }
    }

    setPersonalDetails() {
        this.personalDetails = {} as UserPersonalDetails
        this.personalDetails.UserProfileName = this.user.UserProfile.UserProfileName
        this.personalDetails.OrgID = this.user.UserProfile.OrgID = this.user.UserProfileRoleOrganization.OrgID
        this.selectedRoleID = this.personalDetails.RoleID = this.user.UserProfile.RoleID = this.user.UserProfileRoleOrganization.RoleDefinitionID
        this.getUserTypes()
        this.personalDetails.FirstName = this.user.UserProfile.FirstName
        this.personalDetails.LastName = this.user.UserProfile.LastName
        this.personalDetails.MiddleName = this.user.UserProfile.MiddleName
        if (this.user.UserProfile.MiddleName === '') this.noMiddleName = true
        this.personalDetails.Email = this.user.UserProfile.Email
        this.personalDetails.UID = this.user.UserProfile.UID
        this.personalDetails.LoginPassword = this.user.UserProfile.LoginPassword
        this.personalDetails.BirthdateDecrypted = moment(this.user.UserProfile.BirthdateDecrypted).format('MM/DD/YYYY')
        this.personalDetails.SSNDecrypted = this.user.UserProfile.SSNDecrypted
        if (
            (this.personalDetails.dateofBirth === undefined || this.personalDetails.dateofBirth === null) &&
            this.personalDetails.BirthdateDecrypted !== null &&
            this.personalDetails.BirthdateDecrypted !== '01/01/0001'
        ) {
            this.personalDetails.dateofBirth = new Date(this.personalDetails.BirthdateDecrypted)
        }
        if (
            (this.personalDetails.SSN === undefined || this.personalDetails.SSN === null) &&
            this.personalDetails.SSNDecrypted !== undefined &&
            this.personalDetails.SSNDecrypted !== 0
        ) {
            this.personalDetails.SSN = this.personalDetails.SSNDecrypted
        }
        //this.personalDetails.UID = this.user.UserProfile.UID

        this.personalDetails.UserProfileStatusId = this.user.UserProfile.UserProfileStatusId

        this.personalDetails.UserProfileStatusReason = this.user.UserProfile.UserProfileStatusReason

        this.userProfileStatusReason = this.user.UserProfile.UserProfileStatusReason

        if (
            (this._global.currentUser.isOrganizationalAdmin ||
                this._global.currentUser.isOrganizationalManager ||
                this._global.currentUser.IsAdminOrAgent) &&
            this.user.UserProfile.ProfileStatusDescription !== 'Active' &&
            this.user.UserProfile.ProfileStatusDescription !== 'Inactive'
        ) {
            this.isStatusDisabled = true
        }
        this.personalDetails.ProfileStatusDescription = this.user.UserProfile.ProfileStatusDescription

        this.userProfileID = this.personalDetails.UserProfileID = this.user.UserProfile.UserProfileID
        this.AttestedDetails = this.user.UserProfile.AttestedDetails
        this.personalDetails.OrgName = this.user.UserProfile.OrgName
        this.userDataService.sendData(this.personalDetails.OrgName)
        this.personalDetails.UserLoginType = this.user.UserProfile.UserLoginType

        this.displayEmpID = this.validateEmpID = this.user.UserProfile.UserLoginType === 'Internal' ? true : false

        if (this.personalDetails.MiddleName === undefined || this.personalDetails.MiddleName === null || this.personalDetails.MiddleName === '') {
            this.personalDetails.isNoMidNameChecked = true
        } else {
            this.personalDetails.isNoMidNameChecked = false
        }

        if (this.user.BackGroundCheck != null) {
            this.personalDetails.BGCheck = this.user.BackGroundCheck.BgAuthorized === 1 ? 'Yes' : 'No'
            this.personalDetails.BackGroundCheckDate = this.user.BackGroundCheck.BgAuthorizedDate

            if (this.personalDetails.BackGroundCheckDate !== null) {
                this.personalDetails.BackGroundCheckDateStr = moment(this.personalDetails.BackGroundCheckDate)
                    .subtract(7, 'h')
                    .format('MM/DD/YYYY')
                    .toString()
            } else {
                this.personalDetails.BackGroundCheckDateStr = ''
            }

            this.personalDetails.BgApproved = this.user.BackGroundCheck.BgApproved
            this.bgChkStatus = this.user.BackGroundCheck.BgApproved
            if (this.user.BackGroundCheck.BgApprovedDate != null)
                this.bgChkResultDate = this.personalDetails.BgApprovedDateStr = moment(this.user.BackGroundCheck.BgApprovedDate)
                    .subtract(7, 'h')
                    .format('MM/DD/YYYY')
                    .toString()

            this.personalDetails.BackGroundCheckId = this.user.BackGroundCheck.BackGroundCheckId
        }

        // this.personalDetails.
    }

    UpdateSettingsForAdmin() {
        document.getElementById('divProfile')!.style.display = 'none'
        document.getElementById('divDOB')!.style.display = 'block'

        document.getElementById('divUserTypeAndOrg')!.style.display = 'none'
        this.showCommentsTab = false
        this.showLicenseTab = true
        this.showTrainingTab = false
        this.isLogInDisabled = true
        this.noMiddleName = true
    }

    UpdateSettingsForAdd() {
        this.pageTitle = 'Add User Profile'
        this.isReadOnly = false
        this.noMiddleName = false
    }

    private validateForm() {
        this.ErrorMessages = []

        if (!this.isAdminUpdate) {
            if (
                this.personalDetails.UserProfileName !== undefined &&
                this.personalDetails.UserProfileName !== null &&
                this.personalDetails.UserProfileName !== ''
            ) {
                this.personalDetails.UserProfileName = this.personalDetails.UserProfileName.trim()
                if (/\s/g.test(this.personalDetails.UserProfileName)) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Invalid Login ID')
                }
            } else {
                this.isFormValid = false
                this.ErrorMessages.push('Login ID cannot be blank')
            }

            if (this.mode === 'add') {
                if (
                    this.personalDetails.LoginPassword === undefined ||
                    this.personalDetails.LoginPassword === null ||
                    this.personalDetails.LoginPassword === ''
                ) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Password cannot be blank')
                } else if (
                    this.personalDetails.LoginPassword !== undefined &&
                    this.personalDetails.LoginPassword !== null &&
                    this.personalDetails.LoginPassword !== ''
                ) {
                    if (!this.passwordValidator.isValidPassword(this.personalDetails.LoginPassword)) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Password does not meet requirements. Minimum length is 12 characters.')
                        // .va PasswordTextFieldValidator.isValidPassword
                    }
                }
            }

            if (this.viewUserProfile.OrgID === undefined || this.viewUserProfile.OrgID === null || this.viewUserProfile.OrgID === 0) {
                this.isFormValid = false
                this.ErrorMessages.push('Organization cannot be blank')
            }

            if (this.viewUserProfile.RoleID === undefined || this.viewUserProfile.RoleID === 0) {
                this.isFormValid = false
                this.ErrorMessages.push('User Type cannot be blank')
            }

            if (this.validateEmpID) {
                if (this.personalDetails.UID === undefined || this.personalDetails.UID === '' || this.personalDetails.UID === null) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Employee ID cannot be blank')
                }

                if (this.personalDetails.UID !== undefined && this.personalDetails.UID !== '' && this.personalDetails.UID !== null) {
                    if (!this.isValidNumber(this.personalDetails.UID)) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Employee ID cannot contain letters or special characters')
                    }
                }
            }

            if (this.personalDetails.LastName !== undefined && this.personalDetails.LastName !== null && this.personalDetails.LastName !== '') {
                // if (/^[a-zA-Z0-9]*$/.test(this.personalDetails.LastName)) {
                // this.isFormValid = true;
                // }
                // else {
                //    this.isFormValid = false;
                //    this.ErrorMessages.push('LastName cannot contain special characters')
                // }
                //if (this.personalDetails.LastName.indexOf(' ') != -1) {
                //    this.isFormValid = false
                //    this.ErrorMessages.push('Last Name cannot contain space')
                //}
            }

            if (this.personalDetails.isNoMidNameChecked === undefined || !this.personalDetails.isNoMidNameChecked) {
                if (this.viewUserProfile.MiddleName === undefined || this.viewUserProfile.MiddleName === '') {
                    this.isFormValid = false

                    this.ErrorMessages.push('Middle Name cannot be blank')
                }
            }

            if (this.mode !== 'add') {
                if (this.personalDetails.ProfileStatusDescription.toUpperCase() === 'ACTIVE' && this.personalDetails.BgApproved.toString() !== '1') {
                    this.isFormValid = false
                    this.ErrorMessages.push('Please update background check result.')
                }
                if (this.bgChkStatus === 0 && this.personalDetails.BgApproved !== null && this.personalDetails.BgApproved !== undefined) {
                    if (this.personalDetails.BgApproved.toString() === '1') {
                        let dob = moment(this.personalDetails.dateofBirth, 'MM/DD/YYYY', true)
                        if (
                            this.personalDetails.SSN !== undefined &&
                            this.personalDetails.SSN != null &&
                            (this.personalDetails.SSN === 999999999 || this.personalDetails.SSN.toString() === '000000000')
                        ) {
                            this.isFormValid = false
                            this.ErrorMessages.push('Invalid Social Security Number')
                        }

                        if (dob.isSameOrAfter(moment())) {
                            // if ((dob.format('MM/DD/YYYY') > moment().format('MM/DD/YYYY'))) {
                            this.isFormValid = false
                            this.ErrorMessages.push('Invalid Date of Birth.')
                        } else {
                            if (dob.isSameOrBefore('1900-01-01')) {
                                this.isFormValid = false
                                this.ErrorMessages.push('Invalid Date of Birth.')
                            }
                        }
                    }
                }
            }
            //}

            // }

            if (
                this.viewUserProfile.AgreementVersionNumber === undefined ||
                this.viewUserProfile.AgreementVersionNumber === '' ||
                this.viewUserProfile.AgreementVersionNumber === null
            ) {
                this.isFormValid = false
                this.ErrorMessages.push('Agreement Version Number cannot be blank')
            }

            if (
                this.viewUserProfile.CommissionLevel === undefined ||
                this.viewUserProfile.CommissionLevel === '' ||
                this.viewUserProfile.CommissionLevel === null
            ) {
                this.isFormValid = false
                this.ErrorMessages.push('Commission Level cannot be blank')
            }

            if (this.personalDetails.UserTypeDesc !== undefined && this.personalDetails.UserTypeDesc !== null) {
                if (this.personalDetails.UserTypeDesc === 'Admin-Agent' || this.personalDetails.UserTypeDesc === 'Agent: Marketing') {
                    if (this.viewUserProfile.NIPR === undefined || this.viewUserProfile.NIPR === '' || this.viewUserProfile.NIPR === null) {
                        this.isFormValid = false
                        this.ErrorMessages.push('NPN cannot be blank')
                    }
                }
            }

            if (
                this.viewUserProfile.AgreementVersionNumber !== undefined &&
                this.viewUserProfile.AgreementVersionNumber !== '' &&
                this.viewUserProfile.AgreementVersionNumber !== null
            ) {
                if (!this.isValidNumber(this.viewUserProfile.AgreementVersionNumber)) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Agreement Version Number must be between 0 and 50')
                } else if (parseInt(this.viewUserProfile.AgreementVersionNumber) < 0 || parseInt(this.viewUserProfile.AgreementVersionNumber) > 50) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Agreement Version Number must be between 0 and 50')
                } else {
                    if (this.personalDetails.UserTypeDesc === 'Admin-Agent' || this.personalDetails.UserTypeDesc === 'Agent: Marketing') {
                        if (this.viewUserProfile.CommissionLevel === '0' && parseInt(this.viewUserProfile.AgreementVersionNumber) === 0) {
                            this.isFormValid = false
                            this.ErrorMessages.push('Commission Level/Agreement Version cannot be 0')
                        }
                    } else if (
                        this.personalDetails.UserTypeDesc !== null &&
                        this.personalDetails.UserTypeDesc !== undefined &&
                        this.personalDetails.UserTypeDesc !== 'Admin-Agent' &&
                        this.personalDetails.UserTypeDesc !== 'Agent: Marketing'
                    ) {
                        if (this.viewUserProfile.CommissionLevel === '0') {
                            if (parseInt(this.viewUserProfile.AgreementVersionNumber) !== 0) {
                                this.isFormValid = false
                                this.ErrorMessages.push('Agreement Version Number must be 0 when commission level is set to 0')
                            }
                        }
                    }
                }
            }

            if (this.personalDetails.ProfileStatusDescription === 'Excluded' || this.personalDetails.ProfileStatusDescription === 'Terminated') {
                if (this.personalDetails.UserProfileStatusReason === undefined || this.personalDetails.UserProfileStatusReason === null) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Status Reason cannot be blank')
                }
            }

            var profileOrg = +this.currentUser.orgId
            var profileRole = +this.personalDetails.RoleID

            if (profileOrg === this.personalDetails.OrgID && profileRole === this.currentUser.roleId) {
                if (this.mode === 'add') {
                    this.isFormValid = false
                    this.ErrorMessages.push('Your role level cannot create the User Type you have selected to create')
                } else {
                    if (
                        this.personalDetails.ProfileStatusDescription === 'Pending' ||
                        this.personalDetails.ProfileStatusDescription === 'Preload' ||
                        this.personalDetails.ProfileStatusDescription === 'Active' ||
                        this.personalDetails.ProfileStatusDescription === 'Inactive'
                    ) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Your role level cannot update the User Type you have selected to update')
                    }
                }
                //this.isFormValid = false
                //if (this.mode === 'add')
                //    this.ErrorMessages.push('Your role level cannot create the User Type you have selected to create')
                //else
                //    this.ErrorMessages.push('Your role level cannot update the User Type you have selected to update')
            }
            if (this.userType === undefined || this.userType === null) {
                this.getUserTypes()
            }
            var profileCode = this.userType.filter((x) => x.value === this.personalDetails.RoleID.toString())[0].text
            if (
                profileOrg === this.personalDetails.OrgID &&
                (profileCode.toString() === 'Admin-Agent' || profileCode.toString() === 'Org Manager') &&
                this.currentUser.roleCode === 'Organization Admin'
            ) {
                if (this.mode === 'add') {
                    this.isFormValid = false
                    this.ErrorMessages.push('Your role level cannot create the User Type you have selected to create')
                } else {
                    if (
                        this.personalDetails.ProfileStatusDescription === 'Pending' ||
                        this.personalDetails.ProfileStatusDescription === 'Preload' ||
                        this.personalDetails.ProfileStatusDescription === 'Active' ||
                        this.personalDetails.ProfileStatusDescription === 'Inactive'
                    ) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Your role level cannot update the User Type you have selected to update')
                    }
                }
            }
        }

        if (
            this._global.currentUser.isOrganizationalAdmin ||
            this._global.currentUser.isOrganizationalManager ||
            this._global.currentUser.IsAdminOrAgent
        ) {
            if (
                this.personalDetails.ProfileStatusDescription === 'Pending' ||
                this.personalDetails.ProfileStatusDescription === 'Terminated' ||
                this.personalDetails.ProfileStatusDescription === 'Preload' ||
                this.personalDetails.ProfileStatusDescription === 'Excluded'
            ) {
                if (this.viewUserProfile.ProfileStatusDescription !== this.personalDetails.ProfileStatusDescription) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Your role level cannot update the User status you have selected to update')
                }
            }
        }
        if (
            this._global.currentUser.isOrganizationalAdmin ||
            this._global.currentUser.isOrganizationalManager ||
            this._global.currentUser.IsAdminOrAgent
        ) {
            if (this.isStatusDisabled === true) {
                if (this.personalDetails.UserProfileStatusReason !== null && this.personalDetails.UserProfileStatusReason !== undefined) {
                    if (this.personalDetails.UserProfileStatusReason.toString() !== this.userProfileStatusReason) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Your role level cannot update the User status reason you have selected to update')
                    }
                }
            }
        }

        if (this.personalDetails.Email !== undefined && this.personalDetails.Email !== null && this.personalDetails.Email.trim() !== '') {
            if (!this.isValidEmail(this.personalDetails.Email.trim())) {
                this.isFormValid = false
                this.ErrorMessages.push('Email Address is invalid')
            }
        }

        if (
            this.businessAddress.state.code === undefined ||
            this.businessAddress.state.code === null ||
            this.businessAddress.state.code === '' ||
            this.businessAddress.state.code === '0'
        ) {
            this.isFormValid = false
            this.ErrorMessages.push('Business Address - State cannot be blank')
        }

        if (
            this.residentialAddress.state.code === undefined ||
            this.residentialAddress.state.code === null ||
            this.residentialAddress.state.code === '' ||
            this.residentialAddress.state.code === '0'
        ) {
            this.isFormValid = false
            this.ErrorMessages.push('Residential Address - State cannot be blank')
        }

        if (this.user.Address.length > 0) {
            if (this.user.Address[0].zip4 !== undefined && this.user.Address[0].zip4 !== null && this.user.Address[0].zip4 !== '') {
                if (!this.isValidNumber(this.user.Address[0].zip4)) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Residential  Address - Zip4 can not contain letters or special characters')
                }
                this.zip4text = this.user.Address[0].zip4
                if (this.zip4text.length < 4) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Residential  Address - Zip4 should be exact 4 digits')
                }
            }

            if (this.user.Address.length > 1) {
                if (this.user.Address[1].zip4 !== undefined && this.user.Address[1].zip4 !== null && this.user.Address[1].zip4 !== '') {
                    if (!this.isValidNumber(this.user.Address[1].zip4)) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Business Address - Zip4 can not contain letters or special characters')
                    }
                    this.zip4text = this.user.Address[1].zip4
                    if (this.zip4text.length < 4) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Business Address - Zip4 should be exact 4 digits')
                    }
                }
            }
        }

        // alert(this.viewUserProfile.NIPR)
        if (this.viewUserProfile.NIPR !== undefined && this.viewUserProfile.NIPR !== null) {
            if (this.viewUserProfile.NIPR !== '') {
                if (!this.isValidNumber(this.viewUserProfile.NIPR)) {
                    this.isFormValid = false
                    this.ErrorMessages.push('NPN cannot contain letters or special characters')
                }
            }
        }

        if (this.user.UserPhones.length > 0) {
            for (let i = 0; i < this.user.UserPhones.length; i++) {
                if (this.user.UserPhones[i].PhoneType === 'Cell') {
                    if (
                        this.user.UserPhones[i].Phone !== undefined ||
                        this.user.UserPhones[i].Phone !== null ||
                        this.user.UserPhones[i].Phone !== ''
                    ) {
                        let checkUserCellPhone = this.user.UserPhones[i].Phone
                        if (/^\d{10}$/.test(checkUserCellPhone)) {
                        } else {
                            if (!this.isValidNumber(checkUserCellPhone)) {
                                this.ErrorMessages.push('Cell Phone cannot contain letters or special characters.')
                                this.isFormValid = false
                            } else {
                                this.ErrorMessages.push('Cell Phone must be exactly 10 numbers.')
                                this.isFormValid = false
                            }
                        }
                    }
                }
            }
        }

        if (!this.isAdminUpdate) {
            if (this.mode === 'add') {
                if (this.validateeContract && this.showEContractUserType) {
                    if (
                        this.viewUserProfile.AttestationAccepted === undefined ||
                        this.viewUserProfile.AttestationAccepted === null ||
                        (this.viewUserProfile.AttestationAccepted.toString() === '' && !this.econtractDisable)
                    ) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Please select E-Contract on File as Yes')
                    } else if (this.viewUserProfile.AttestationAccepted !== '1' && !this.econtractDisable) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Please select E-Contract on File as Yes')
                    }
                }
            }
            //else {
            //    if (this.validateeContract && this.showEContractUserType) {

            //        if (this.viewUserProfile.AttestationAccepted === undefined || this.viewUserProfile.AttestationAccepted === null ||
            //            this.viewUserProfile.AttestationAccepted.toString() === '') {
            //            this.isFormValid = false
            //            this.ErrorMessages.push('Please select E-Contract on File as Yes or No')

            //        }
            //    }
            //}

            if (this.viewUserProfile.TextMessageOptIn === undefined || this.viewUserProfile.TextMessageOptIn === '') {
                this.isFormValid = false
                this.ErrorMessages.push('Text Message Opt In cannot be blank')
            }
            if (
                this.viewUserProfile.TextMessageOptIn !== undefined &&
                this.viewUserProfile.TextMessageOptIn !== '' &&
                this.viewUserProfile.TextMessageOptIn === '1'
            ) {
                let celltext = false
                if (this.user.UserPhones.length > 0) {
                    for (let i = 0; i < this.user.UserPhones.length; i++) {
                        if (this.user.UserPhones[i].PhoneType === 'Cell') {
                            celltext = true
                            if (
                                this.user.UserPhones[i].Phone === undefined ||
                                this.user.UserPhones[i].Phone === null ||
                                this.user.UserPhones[i].Phone === ''
                            ) {
                                //  if (this.cellPhone.Phone === undefined || this.cellPhone.Phone === null || this.cellPhone.Phone === '') {
                                this.isFormValid = false
                                this.ErrorMessages.push('Cell Number required for Text Messaging Opt In')
                            }
                        }
                    }
                    if (!celltext) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Cell Number required for Text Messaging Opt In')
                    }
                } else {
                    this.isFormValid = false
                    this.ErrorMessages.push('Cell Number required for Text Messaging Opt In')
                }
            }
        }
    }

    getStatusReason() {
        this.comLevelGateway
            .getAllCommissionLevel(this.viewUserProfile.ProfileStatusDescription)
            .subscribe((statusReasonModel: ValidatedSelectOptionModel[]) => {
                this.userStatusReason = statusReasonModel

                if (statusReasonModel !== undefined || statusReasonModel !== null) {
                    if (statusReasonModel.length > 0) {
                        document.getElementById('divStatusreason')!.style.display = 'block'
                    }
                }
            })
    }
    //onKeyDown(event) {
    //    const ENTER_KEY = 13
    //    if (event.keyCode === ENTER_KEY) {
    //        this.submitForm()
    //    }
    //}

    showTabbed(screen: number) {
        this.commentsScreenShow = false
        this.licenseScreenShow = false
        this.trainingScreenShow = false
        if (screen === 1) {
            this.commentsScreenShow = true
            this.getUserComments()
        }
        if (screen === 3) {
            this.trainingScreenShow = true
        }
        if (screen === 2) {
            this.licenseScreenShow = true
            this.getUserLicense()
        }
    }

    UpdateSettingsForEdit() {
        this.showCommentsTab = true
        this.showLicenseTab = true
        this.showTrainingTab = true
    }

    validateEContract(validate: boolean) {
        this.validateeContract = validate
        this.showEContractOrg = validate
        this.displayEContract(validate, this.showEContractUserType)
    }

    Cancel() {
        if (this.currentUser !== undefined && this.currentUser !== null) {
            //if (this.currentUser.IsGuruAdmin || this.currentUser.IsSuperAdminAdmin
            //    || this.currentUser.IsImAdminOrAbove || this.currentUser.IsSuperAdminSMA || this.currentUser.IsSuperAdminSMM) {
            //}
            //else {
            //    this.routers.navigate(['/home'])
            //}
            if (this.isAdminUpdate) this.routers.navigate(['/' + this.insCo + '/home'])
            else if (this.isfromUserSearch !== undefined && this.isfromUserSearch) {
                this.routers.navigate(['/' + this.insCo + '/user-management/user-list'])
            } else {
                this.routers.navigate(['/' + this.insCo + '/user-management/user-list/user-search'])
            }
        } else {
            this.routers.navigate(['/' + this.insCo + '/home'])
        }
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    getUserTypes() {
        this.userTypeGateway.getUserBasedRole().subscribe((userTypemodel: ValidatedSelectOptionModel[]) => {
            this.userType = userTypemodel
            this.userType.unshift({ value: 0, text: '-- Choose One --' })

            if (this.selectedRoleID !== undefined && this.selectedRoleID !== null && this.selectedRoleID !== 0)
                this.getUserTypeDesc(this.selectedRoleID.toString())
            else this.personalDetails.RoleID = 0

            console.log(this.userType)
        })
    }

    getUserTypeDesc(userTypeID: string) {
        this.userTypeDescription = ''
        if (this.userType !== undefined && this.userType !== null) {
            this.personalDetails.UserTypeDesc = this.userType.filter((x) => x.value === userTypeID)[0].text

            if (this.personalDetails.UserTypeDesc === 'Agent: Marketing' || this.personalDetails.UserTypeDesc === 'Admin-Agent') {
                this.isRequired = true
            } else {
                this.isRequired = false
            }
        }
    }

    userTypeSelection(requiredInd: boolean) {
        this.isRequired = requiredInd
    }
    userTypeSelectionEContract(contract: boolean) {
        this.showEContractUserType = contract
        this.displayEContract(this.showEContractOrg, contract)
    }
    displayEContract(showOrg: boolean, userType: boolean) {
        if (this.mode === 'edit') {
            this.showEContract = true
            this.econtractDisable = true
        } else {
            this.econtractDisable = false
            if (showOrg && userType) {
                this.showEContract = true
            } else {
                this.showEContract = false
            }
        }
    }

    setEmpIDValidation(validateEmpID: boolean) {
        this.validateEmpID = validateEmpID
    }
    getUserTypesForEcontract() {
        this.userTypeGateway.getUserBasedRole().subscribe((userTypemodel: ValidatedSelectOptionModel[]) => {
            this.userType = userTypemodel
            this.userType.unshift({ value: 0, text: '-- Choose One --' })

            if (this.userType !== undefined && this.userType !== null) {
                let UserTypeDesc = this.userType.filter((x) => x.value === this.viewUserProfile.RoleID.toString())[0].text

                if (
                    !(
                        UserTypeDesc === 'Super Admin SMM' ||
                        UserTypeDesc === 'Super Admin SMA' ||
                        UserTypeDesc === 'Admin: Super' ||
                        UserTypeDesc === 'Org Manager' ||
                        UserTypeDesc === 'eViewer' ||
                        UserTypeDesc === 'Auditor' ||
                        UserTypeDesc === 'Admin: Guru'
                    )
                ) {
                    this.showEContractUserType = true
                    this.displayEContract(this.showEContractOrg, this.showEContractUserType)
                }
            }
        })
    }
}
